import styled from 'styled-components';

export const FileItemStatuses = {
  loading: { name: 'loading', color: 'var(--cvna-color-blue-2)' },
  success: { name: 'success', color: 'var(--cvna-color-green-1)', fontColor: 'var(--cvna-color-green-2)' },
  warning: { name: 'warning', color: 'var(--cvna-color-red-1)', fontColor: 'var(--cvna-color-red-2)' },
  typeError: { name: 'typeError', color: 'var(--cvna-color-red-1)', fontColor: 'var(--cvna-color-red-2)' },
  sizeError: { name: 'sizeError', color: 'var(--cvna-color-red-1)', fontColor: 'var(--cvna-color-red-2)' },
};

export const File = styled.div<{
  status: keyof typeof FileItemStatuses;
  children?: any;
}>`
  font-size: 16px;
  font-weight: 450;
  color: var(--cvna-color-blue-6);
  width: 100%;
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-template-rows: auto;
  grid-template-areas:
    'fileName fileAction'
    'status .';
  justify-items: start | end;
  align-items: center;
  row-gap: 8px;
  column-gap: 8px;
  margin-bottom: 16px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) =>
      props.status === FileItemStatuses.success.name &&
      `
      grid-template-areas:
        "fileName status";
       grid-template-columns: max-content 1fr;
    `}
  }
`;

export const FileName = styled.div`
  grid-area: fileName;
  word-wrap: anywhere;
`;

export const Status = styled.div<{
  status: keyof typeof FileItemStatuses;
  children?: any;
}>`
  grid-area: status;
  color: var(--cvna-color-white);
  background-color: ${(props) => FileItemStatuses[props.status].color};
  color: ${(props) => (FileItemStatuses[props.status] as any)?.fontColor || 'var(--cvna-color-white)'};
  font-size: 12px;
  line-height: 16px;
  padding: 6px 12px;
  border-radius: 2px;
  justify-self: start;
`;

export const FileAction = styled.button`
  grid-area: fileAction;
  border: none;
  background-color: transparent;
  color: var(--cvna-color-blue-2);
  cursor: pointer;
  font-size: 16px;
  font-weight: 390;
  width: auto;

  &:active,
  &:focus {
    outline: none;
  }

  &:hover {
    color: var(--cvna-color-blue-3);
  }
`;
